import { useEffect } from 'react'

export default function AuthCallback() {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search)
    const token = params.get('token')
    const error = params.get('error')

    if (error) {
      window.location.href = '/login?error=' + encodeURIComponent(error)
      return
    }

    if (!token) {
      window.location.href = '/login?error=missing_token'
      return
    }

    localStorage.setItem('auth_token', token)
    window.location.href = '/app'
  }, [])

  return (
    <div className="min-h-screen bg-aethex-bg flex items-center justify-center font-mono">
      <div className="text-center">
        <div className="w-8 h-8 border-2 border-aethex-primary border-t-transparent animate-spin mx-auto mb-4" />
        <p className="text-aethex-dim text-xs uppercase tracking-widest">Signing you in…</p>
      </div>
    </div>
  )
}
